import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import PermissionRequired from "@surgia/ui/pages/PermissionRequired";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermissions?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermissions = [],
}) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  const { globalState } = useSelector((state: RootState) => state.auth);
  const isReduxAuthenticated =
    globalState?.access_token && globalState?.subject_id;
  const userPermissionNames =
    globalState?.user_permissions?.map((p) => p.name) || [];
  const hasPermission =
    requiredPermissions.length === 0 ||
    requiredPermissions.every((permission) =>
      userPermissionNames.includes(permission)
    );

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated && !isReduxAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasPermission && requiredPermissions.length > 0) {
    return <PermissionRequired />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
